import { Layout, DesiredSwitchSystem } from "components"
export const Switch = () => {
 return (
  <Layout>
   <DesiredSwitchSystem />
  </Layout>
 )
}
